module.exports = __webpack_public_path__ + "img/arrow.93e4d402.svg";